<template>
  <CommonNoticeCard
    :class="[b()]"
  >
    <div
      slot="title"
      :class="b('title')"
      v-html="title"
    />
    <template #actions>
      <el-button
        type="plaintext2"
        @click.stop="continueEdit"
      >
        {{ $t('edit.button.continueEdit') }}
      </el-button>
    </template>
  </CommonNoticeCard>
</template>

<script>
import CommonNoticeCard from '@/components/notice/CommonNoticeCard';
import theme from '@zk/theme/lib/variables.scss';
import { noop } from 'lodash';

export default {
  name: 'BatchUpdateNoticeCard',
  components: { CommonNoticeCard },
  bemNS: theme.bemNS,
  props: {
    count: {
      type: Number,
      required: true
    },
    callback: {
      type: Function,
      default: noop
    }
  },
  data() {
    return {
    };
  },
  computed: {
    title() {
      return this.$tc('edit.update.successMsg', this.count, [this.count]);
    }
  },
  methods: {
    continueEdit() {
      this.$parent.close();
      this.callback();
    }
  }
};
</script>

<style lang="scss">
@include b(batch-update-notice-card) {
  @include e(title) {
    color: var(--font-color-1);
    & > span {
      margin-right: var(--m-small);
      color: #0EAD69;
      font-weight: var(--weight-font-Blod);
    }
  }
  .el-button.is-icon {
    color: var(--primary-color);
  }
}
</style>
